module.exports = __webpack_public_path__ + "static/media/long-short-attribution.d9ac6710.png";